export function prefixLocalStorageKey(prefix, key) {
  return "".concat(prefix, "-").concat(key);
}